export default __webpack_public_path__ + "media/images/icons/arrow-down-6192b2b913afbdd17d551b17b57fde45.svg";